/**
 * InterviewTrackingCard - Tracking des auto-interviews
 * Extrait de Profile.js pour améliorer la maintenabilité
 * AMIRAUX UNIQUEMENT
 */
import React from 'react';
import { TrendingUp } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';

export const InterviewTrackingCard = () => (
  <Card className="relative bg-cyan-950/15 backdrop-blur-xl border-cyan-800/40" data-testid="card-interview-tracking">
    <CardHeader>
      <CardTitle className="text-xl md:text-2xl font-orbitron uppercase tracking-wider text-cyan-400 flex items-center">
        <TrendingUp className="w-5 h-5 md:w-6 md:h-6 mr-2 md:mr-3" />
        Tracking Auto-Interviews
      </CardTitle>
    </CardHeader>
    <CardContent>
      <p className="text-sm text-slate-400 mb-4">
        Suivi par rédacteur du nombre d&apos;auto-interviews lancées et publiées. Objectif : 1 par jour ouvré.
        Relances automatiques chaque mardi et vendredi à 17h aux rédacteurs inactifs.
      </p>
      <Button
        onClick={() => window.location.assign('/admin/interview-tracking')}
        className="bg-cyan-500/10 hover:bg-cyan-500/20 text-cyan-400 border border-cyan-500/50 hover:border-cyan-400"
        data-testid="btn-open-interview-tracking"
      >
        <TrendingUp className="w-4 h-4 mr-2" />
        Consulter le tableau de bord
      </Button>
    </CardContent>
  </Card>
);

export default InterviewTrackingCard;
